import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular/standalone';
import { Subscription } from 'rxjs';
import { App } from '@capacitor/app';
import { Router } from '@angular/router';

const ROOT_ROUTES = [
  '/feed',
  '/search',
  '/project',
  '/participation',
  '/following',
  '/settings',
] as const;

@Injectable({ providedIn: 'root' })
export class BackButtonService {
  private backSubscription: Subscription;
  private readonly rootPages: string[] = [...ROOT_ROUTES];
  private readonly homePath = ROOT_ROUTES[0];

  constructor(
    private platform: Platform,
    private modalController: ModalController,
    private router: Router
  ) {}

  attach() {
    if (this.backSubscription) {
      return;
    }

    this.backSubscription = this.platform.backButton.subscribeWithPriority(
      100000,
      async (processNextHandler) => {
        const element = await this.modalController.getTop();
        const currentUrl = this.router.url;
        const isRoot = this.rootPages.includes(currentUrl);

        if (element) {
          await element.dismiss();
          return false;
        }

        if (isRoot) {
          if (currentUrl === this.homePath) {
            App.exitApp();
          } else {
            await this.router.navigateByUrl(this.homePath, {
              replaceUrl: true,
            });
          }

          return false;
        }

        processNextHandler();
        return true;
      }
    );
  }

  detach() {
    if (!this.backSubscription) {
      return;
    }

    this.backSubscription.unsubscribe();
    this.backSubscription = null;
  }
}
